<div #infoTooltip  class="db-info-tooltip" [ngStyle]="infoTooltipStyle"
     [ngClass]="{'db-info-tooltip-premium-plugin-upgrade': premiumUpgrade}">
  <div class="db-info-tooltip__content {{dbInfoTooltipCustomClass}}" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()" [ngClass]="{'db-info-tooltip-black-theme': dbInfoTooltipClass, 'mobile-view': isMobile}">
    <div [ngClass]="{'db-with-link': infoTooltipMoreInfoLink}">
      <div class="db-info-tooltip__content-header" *ngIf="infoTooltipHeader">{{infoTooltipHeader}}</div>
      <div class="db-info-tooltip__content-body" [ngClass]="{'db-with-link': infoTooltipMoreInfoLink}" [innerHTML]="infoTooltipBody"></div>
      <div class="db-info-tooltip__content-more-info-link" *ngIf="infoTooltipMoreInfoLink">
        <a class="db-link" [routerLink]="infoTooltipMoreInfoLink"><span>{{infoTooltipMoreInfoLinkText}}</span></a>
      </div>
      <div class="db-info-tooltip__content-more-info" *ngIf="infoTooltipMoreInfo">
        <a class="db-button db-button_info" [href]="infoTooltipMoreInfo" target="_blank" rel="noopener"><span>{{'text_getMoreInfo' | dbText}}</span></a>
      </div>
    </div>
  </div>
</div>
